export interface DvfDisplayRangeMm {
    lowMm: number;
    highMm: number;
}

export function clampDvfDisplayRange(
    lowMm: number | undefined,
    highMm: number | undefined,
    maxMagnitudeMm: number
): DvfDisplayRangeMm {
    const full = { lowMm: 0, highMm: maxMagnitudeMm };
    const low = Math.max(0, lowMm ?? 0);
    const high = Math.min(highMm ?? maxMagnitudeMm, maxMagnitudeMm);
    return high > low ? { lowMm: low, highMm: high } : full;
}
